import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";

import { WFPButton } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getTraderRepresentativeFullName } from "../traderRepresentativeUtils";
import type {
  RepresentativeActionHandler,
  TraderRepresentative,
  TranslationFunction,
} from "../types";

interface TraderRepresentativeActionsMenuProps {
  representative: TraderRepresentative;
  onClickDeleteRepresentative: RepresentativeActionHandler;
  onClickEditRepresentative: RepresentativeActionHandler;
  t: TranslationFunction;
}

export const TraderRepresentativeActionsMenu = ({
  representative,
  onClickDeleteRepresentative,
  onClickEditRepresentative,
  t,
}: TraderRepresentativeActionsMenuProps) => {
  const actionLabel = "Actions";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <WFPButton
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={`${actionLabel}: ${getTraderRepresentativeFullName(representative)}`}
        >
          <MoreHorizontal className="size-4" />
        </WFPButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => onClickEditRepresentative(representative)}>
          <Pencil className="size-4" />
          {t("common.edit")}
        </DropdownMenuItem>
        <DropdownMenuItem
          variant="destructive"
          onSelect={() => onClickDeleteRepresentative(representative)}
        >
          <Trash2 className="size-4" />
          {t("common.delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export type { TraderRepresentativeActionsMenuProps };
